import { render, staticRenderFns } from "./history-item.vue?vue&type=template&id=2b57ac6c&scoped=true&"
import script from "./history-item.vue?vue&type=script&lang=js&"
export * from "./history-item.vue?vue&type=script&lang=js&"
import style0 from "./history-item.vue?vue&type=style&index=0&id=2b57ac6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b57ac6c",
  null
  
)

export default component.exports